import { useRouter } from 'next/router'

import { faSlidersSimple, faUserGroup } from '@fortawesome/pro-light-svg-icons'

import { ProjectRole } from '@infura/packages.api'
import { Product } from '@infura/packages.teams'
import { ActionBar } from '@infura/packages.ui/ActionBar'
import { ActionLink } from '@infura/packages.ui/ActionLink'
import { Button } from '@infura/packages.ui/Button'

import { useSelectedApiKey, useSetSelectedApiKey } from 'components/keySelection/Context'
import { SharingProjectDropdown } from 'components/sharing/SharingProjectDropdown'

import useProjectRoles from 'hooks/useProjectRoles'

const apiKeyPaths = ['/key', '/developer-api', '/mm-sdk', '/dashboard/stats', '/dashboard/explorer']

export const KeysHeader = () => {
  const { loading, projects, selectedKey } = useSelectedApiKey()
  const setSelectedKey = useSetSelectedApiKey()
  const router = useRouter()
  const roles = useProjectRoles()

  if (!apiKeyPaths.some(path => router.pathname.startsWith(path))) {
    return
  }

  return (
    <ActionBar className='bg-background-alternative' id='onboarding-tour-chosen-key' wrap>
      <div className='flex w-full flex-col items-baseline gap-y-4 lg:flex-row lg:items-start lg:gap-y-0'>
        <div className='flex w-full flex-wrap items-center justify-between gap-2'>
          <ApiKeySelector
            handleKeyChange={setSelectedKey}
            isLoading={loading}
            projects={projects}
            roles={roles}
            selectedKey={selectedKey}
          />
        </div>
      </div>
    </ActionBar>
  )
}

const sharingRoles: Array<ProjectRole> = [ProjectRole.OWNER, ProjectRole.ADMIN]
function ApiKeySelector({ handleKeyChange, isLoading, projects, roles, selectedKey }) {
  if (isLoading) {
    return <LoadingState />
  }

  if (!projects?.ethereum || projects?.ethereum?.length === 0) {
    return <div>No projects found</div>
  }

  const projectRole = projects?.ethereum?.find(p => p.id === selectedKey)?.role
  const canShare = sharingRoles.includes(projectRole)

  return (
    <>
      <SharingProjectDropdown
        displayMode='all'
        groupBy='product'
        includeAllOption={false}
        onChange={({ id }) => {
          handleKeyChange(id)
        }}
        product={Product.ETHEREUM}
        projects={projects}
        roles={roles}
        selectedProjectId={selectedKey as string}
        testId='global-key-selector'
      />

      <span className='flex gap-4'>
        {canShare ? (
          <ActionLink dataTestId='key-sharing-link' href='/key/sharing' icon={faUserGroup} iconPosition='left'>
            Key Sharing
          </ActionLink>
        ) : null}
        <ActionLink href='/key/settings' icon={faSlidersSimple} iconPosition='left'>
          Configure
        </ActionLink>
      </span>
    </>
  )
}

const LoadingState = () => {
  return (
    <Button
      aria-label='add api method'
      data-testid='submit-methods'
      disabled={true}
      loading={true}
      theme='secondary'
      type='submit'
    ></Button>
  )
}
